export default {
  time: {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    },
    hhmm: {
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  date: {
    fullDateLong: {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    },
    fullDateShort: {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    },
    fullDateWithDayOfWeek: {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    },
    mmddyy: {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit'
    },
    mmddyyyy: {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    },
    monthDay: {
      month: 'short',
      day: 'numeric'
    },
    fullMonthDay: {
      month: 'long',
      day: 'numeric'
    },
    shortMonthYear: {
      month: 'short',
      year: 'numeric'
    },
    shortNumericMonthYear: {
      month: '2-digit',
      year: 'numeric'
    },
    longMonthYear: {
      month: 'long',
      year: 'numeric'
    },
    fullDateLongTimeZone: {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short'
    },
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  },
  number: {
    EUR: {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    USD: {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    GBP: {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    JPY: {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }
};